import React from 'react';
import { GapSizeType } from '../../../theme/type/gap-type';
import { cn } from '../../../utils/tailwind';

interface StackProps {
    children: Array<React.ReactNode> | React.ReactNode;
    direction?: 'vertical' | 'horizontal';
    alignItems?: 'flex-start' | 'center' | 'flex-end' | 'stretch';
    gap?: GapSizeType;
    justifyContent?: 'space-between' | 'space-around' | 'space-evenly' | 'flex-start' | 'flex-end' | 'center';
    fullHeight?: boolean;
    fullWidth?: boolean;
}

const directionClass: Record<NonNullable<StackProps['direction']>, string> = {
    vertical: 'flex-col',
    horizontal: 'flex-row',
};

const gapClass: Record<GapSizeType, string> = {
    none: 'gap-none',
    xxsmall: 'gap-xxsmall',
    xsmall: 'gap-xsmall',
    vsmall: 'gap-vsmall',
    small: 'gap-small',
    medium: 'gap-medium',
    large: 'gap-large',
    vlarge: 'gap-vlarge',
    xlarge: 'gap-xlarge',
    xxlarge: 'gap-xxlarge',
};

const alignItemsClass: Record<NonNullable<StackProps['alignItems']>, string> = {
    'flex-start': 'items-start',
    center: 'items-center',
    'flex-end': 'items-end',
    stretch: 'items-stretch',
};

const justifyContentClass: Record<NonNullable<StackProps['justifyContent']>, string> = {
    'space-between': 'justify-between',
    'space-around': 'justify-around',
    'space-evenly': 'justify-evenly',
    'flex-start': 'justify-start',
    'flex-end': 'justify-end',
    center: 'justify-center',
};

export const Stack: React.FC<StackProps> = ({
    children,
    direction = 'horizontal',
    gap = 'xsmall',
    alignItems = 'flex-start',
    justifyContent = 'center',
    fullHeight,
    fullWidth,
}) => {
    return (
        <div
            className={cn(
                'inline-flex',
                directionClass[direction],
                gapClass[gap],
                alignItemsClass[alignItems],
                justifyContentClass[justifyContent],
                fullHeight && 'h-full',
                fullWidth && 'w-full',
            )}
        >
            {children}
        </div>
    );
};
